import React from "react";

// Package Import
import { useLocation } from "react-router-dom";

// User Import

import RequestDetails from "./Details/Request";
import BatchDetails from "./Details/Batch";
import NodeDetails from "./Details/Node";

// Component

const DetailsPage = () => {
	// Hooks
	const { state } = useLocation();

	// states
  const switchComponent = () => {
		switch (state?.detailsType) {
			case "request":
				return <RequestDetails request={state?.detailsData} />;
			case "batch":
				return <BatchDetails batch={state?.detailsData} />;
			case "node":
				return <NodeDetails node={state?.detailsData} />;
		}
	};

	const detailsComponent = switchComponent();

	return <>{detailsComponent}</>;
};

export default DetailsPage;
